import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { Typography } from 'ui-v2/components/Typography';
import { LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import s from './ImageScrollListing.module.scss';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
export const ImageScrollListing = ({ data }: LayoutPropType) => {
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });
  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.layoutType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.title);
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);
  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) =>
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType,
          data?.data,
          data?.title
        )
      }
    >
      <Typography label={data?.title} variant="label_1_bold" className={s.title} />
      <div className={s.container}>
        {data?.data?.map((item, index) => (
          <div
            key={item?.productId}
            className={s.item}
            id={CARDID}
            data-index={index}
          >
            <AnimatedImage src={item?.coverImage} alt='imageCover' />
          </div>
        ))}
      </div>
    </div>
  );
};
